import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';

interface Props {
  disabled?: boolean;
  outerStyle?: StyleProp<ViewStyle>;
  selected: boolean;
}

export const RadioButton: React.FC<Props> = ({
  disabled,
  outerStyle,
  selected,
}) => {
  const [styles] = useStyles();
  return (
    <View
      style={[
        styles.outer,
        disabled ? styles.disabledOuter : undefined,
        outerStyle,
      ]}
    >
      {selected ? (
        <View
          style={[styles.inner, disabled ? styles.disabledInner : undefined]}
        />
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  disabledInner: {
    backgroundColor: theme.colors.inactiveText,
  },
  disabledOuter: {
    borderColor: theme.colors.inactiveText,
  },
  inner: {
    backgroundColor: theme.colors.primary,
    borderRadius: 10,
    height: 10,
    width: 10,
  },
  outer: {
    alignItems: 'center',
    borderColor: theme.colors.primary,
    borderRadius: 18,
    borderWidth: 1,
    height: 18,
    justifyContent: 'center',
    width: 18,
  },
}));
